import { render, staticRenderFns } from "./distributionOperationData.vue?vue&type=template&id=480961eb&scoped=true"
import script from "./distributionOperationData.vue?vue&type=script&lang=js"
export * from "./distributionOperationData.vue?vue&type=script&lang=js"
import style0 from "./distributionOperationData.vue?vue&type=style&index=0&id=480961eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480961eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480961eb')) {
      api.createRecord('480961eb', component.options)
    } else {
      api.reload('480961eb', component.options)
    }
    module.hot.accept("./distributionOperationData.vue?vue&type=template&id=480961eb&scoped=true", function () {
      api.rerender('480961eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/waybillKanbanBoard/component/distributionOperationData.vue"
export default component.exports